(function(window, document, $, undefined){

  // var mySwiper = new Swiper ('.swiper-container', {
  //       speed: 1000,
  //       slidesPerView: 'auto',
  //       direction: 'horizontal',
  //       // effect: 'fade',
  //       autoHeight: true,
  //       loop: true,
  //       autoplay: {
  //         delay: 5000,
  //         disableOnInteraction: false,
  //       },
  //       breakpoints: {
  //         991: {
  //           slidesPerView: 1,
  //           effect: 'fade',
  //         },
  //       }
  //     });


  // var megaMenuMobileSwiper = new Swiper ('.mega-menu-navigation .mega-menu', {
  //       speed: 500,
  //       direction: 'horizontal',
  //       wrapperClass: 'menu-mega-menu',
  //       slideClass: 'no-js',
  //       // effect: 'fade',
  //       // slideNextClass: 'swiper-slide-next',
  //       // slidePrevClass: 'swiper-slide-prev',
  //       navigation: {
  //           nextEl: '.swiper-slide-next',
  //           prevEl: '.swiper-slide-prev',
  //         },
  //       autoHeight: true,
  //       loop: true,
  //     });

// function viewport() {
//     var e = window, a = 'inner';
//     if (!('innerWidth' in window )) {
//         a = 'client';
//         e = document.documentElement || document.body;
//     }
//     return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
// }
if($('.mega-menu-navigation .mega-menu DISABLED').length){

  function getWidth(){
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    return w;
  }

  var megaMenuMobileSwiper = undefined;
  var breakpoint = 1150;
  // console.log('viewport.width',w);

  function initSwiper() {
      var screenWidth = getWidth();
      if(screenWidth <= breakpoint && megaMenuMobileSwiper == undefined) {            
          megaMenuMobileSwiper = new Swiper ('.mega-menu-navigation .mega-menu', {
            speed: 500,
            direction: 'horizontal',
            wrapperClass: 'menu-mega-menu',
            slideClass: 'no-js',

            observer: true, //needed for when its hidden
            observeParents: true,//needed for when its hidden
            
            // effect: 'fade',
            // slideNextClass: 'swiper-slide-next',
            // slidePrevClass: 'swiper-slide-prev',
            navigation: {
                nextEl: '.swiper-slide-next',
                prevEl: '.swiper-slide-prev',
            },
            scrollbar: {
              el: '.swiper-scrollbar',
              draggable: true,
            },
            autoHeight: true,
            // loop: true,
          });


          // var $scrollbarDrag = $('.mega-menu-navigation .swiper-scrollbar-drag');
          // var _carouselTranslateScrollbar = function(progress) {
          //   var swiper = this;
          //   var increaseRatio = 2,
          //     increasedProgress = progress * increaseRatio,
          //     slidesLength = swiper.slides.length - 1,
          //     activeSlide = Math.round((progress * slidesLength) + 1),
          //     slideFraction = 1 / slidesLength,
          //     progressBetweenSlide = (increasedProgress % slideFraction) * slidesLength,
          //     progressBetweenSlideReversed = progressBetweenSlide === 0 ? 0 : 1 - progressBetweenSlide,
          //     widthPercent = 100 / swiper.slides.length,
          //     widthAndProgress = (widthPercent * activeSlide) + (widthPercent * progressBetweenSlide),
          //     widthFixed = (widthPercent * activeSlide),
          //     leftPosition = (widthPercent * (activeSlide - 1)) - (widthPercent * progressBetweenSlideReversed),
          //     leftFixed = (widthPercent * (activeSlide - 1));
          //   var pos = (progress % slideFraction);
          //   // @TODO sort selector
          //   if (pos === 0 || pos > (slideFraction / 2)) {
          //     $('.mega-menu-navigation .swiper-scrollbar-drag').css({
          //       'background-color': '#000',
          //       'right': (100 - widthFixed) + '%',
          //       'left': leftPosition + '%'
          //     });
          //   } else {
          //     $('.mega-menu-navigation .swiper-scrollbar-drag').css({
          //       'background-color': '#666',
          //       'right': (100 - widthAndProgress) + '%',
          //       'left': leftFixed + '%'
          //     });

          //   }
          // };
          // var _carouselSetTransitions = function(transition) {
          //   var swiper = this;
          //   $scrollbarDrag.css('transition-duration', transition + 'ms');
          // };
          // megaMenuMobileSwiper.on('progress', _carouselTranslateScrollbar);
          // megaMenuMobileSwiper.on('setTransition', _carouselSetTransitions);



      } else if (screenWidth > breakpoint && megaMenuMobileSwiper !== undefined) {
        console.log('megaMenuMobileSwiper',megaMenuMobileSwiper);
          megaMenuMobileSwiper.destroy();
          megaMenuMobileSwiper = undefined;
          jQuery('.mega-menu-navigation .mega-menu .menu-mega-menu').removeAttr('style');
          jQuery('.mega-menu-navigation .mega-menu .no-js').removeAttr('style');            
      }        
  }








  














  //Swiper plugin initialization
  initSwiper();

  //Swiper plugin initialization on window resize
  $(window).on('resize', function(){
      initSwiper();        
  });

} //end if length check


  // // breakpoint where swiper will be destroyed
  // // and switches to a dual-column layout
  // const breakpoint = window.matchMedia( '(max-width:1000px)' );
  // // keep track of swiper instances to destroy later
  // let mySwiper;
  // const breakpointChecker = function() {
  //    // if larger viewport and multi-row layout needed
  //    if ( breakpoint.matches === true ) {
  //       // clean up old instances and inline styles when available
  //       if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
  //       // or/and do nothing
  //       return;
  //    // else if a small viewport and single column layout needed
  //    } else if ( breakpoint.matches === false ) {
  //       // fire small viewport version of swiper
  //       return enableSwiper();
  //    }
  // };
  // const enableSwiper = function() {
  //    mySwiper = new Swiper ('.mega-menu-navigation .mega-menu', {
  //       speed: 500,
  //       direction: 'horizontal',
  //       wrapperClass: 'menu-mega-menu',
  //       slideClass: 'no-js',
  //       // effect: 'fade',
  //       // slideNextClass: 'swiper-slide-next',
  //       // slidePrevClass: 'swiper-slide-prev',
  //       navigation: {
  //           nextEl: '.swiper-slide-next',
  //           prevEl: '.swiper-slide-prev',
  //         },
  //       autoHeight: true,
  //       loop: true,
  //     });
  // };
  // // keep an eye on viewport size changes
  // breakpoint.addListener(breakpointChecker);
  // // kickstart
  // breakpointChecker();







  // var upcomingEvents = new Swiper ('.upcoming-events-swiper-container', {
  //           speed: 500,
  //           direction: 'horizontal',
  //           wrapperClass: 'vc_inner',
  //           slideClass: 'vc_column_container',

  //           observer: true, //needed for when its hidden
  //           observeParents: true,//needed for when its hidden
            

  //           // navigation: {
  //           //     nextEl: '.swiper-slide-next',
  //           //     prevEl: '.swiper-slide-prev',
  //           // },
  //           // scrollbar: {
  //           //   el: '.swiper-scrollbar',
  //           //   draggable: true,
  //           // },
  //           autoHeight: true,
  //     });











  var todaysNews = new Swiper ('.todays-news .swiper-container', {
        speed: 1000,
        direction: 'horizontal',
        // effect: 'fade',
        autoHeight: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });


  var mySwiper = new Swiper ('.circle-nav .swiper-container', {
        // speed: 1000,
        slidesPerView: 'auto',
        direction: 'horizontal',
        // effect: 'fade',
        // autoHeight: true,
        // loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
      });


  if($('.more_in_category .swiper-container').length) {
    var slides_per_view = 4;
    if($('.more_in_category .swiper-container').attr('data-slides-per-view').length) {
    // console.log('ddddew',$('.more_in_category .swiper-container').attr('data-slides-per-view'));
      var slides_per_view = parseInt($('.more_in_category .swiper-container').attr('data-slides-per-view'));
    }
    // console.log('slides_per_view',slides_per_view);
    var breakpoints = {};
    switch(slides_per_view) {
      case 5:
        breakpoints = {
          // slidespreview = X up until [breakpoint width]
          1024: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 4,
          },
          600: {
            slidesPerView: 3,
          },
          375: {
            slidesPerView: 2,
          }
        };
      break;
      default:
        slides_per_view = 4;
        breakpoints = {
          // last breakpoint and higher = slidesperView var
          1024: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 3,
          },
          600: {
            slidesPerView: 2,
          },
          375: {
            slidesPerView: 1,
          }
        };
      break;
    }
    var moreInCategory = new Swiper ('.more_in_category .swiper-container', {
        // slideClass: 'article.block',
        // wrapperClass: 'flexlist',
        speed: 500,
        direction: 'horizontal',
        slidesPerView: slides_per_view,
        spaceBetween: 20,
        // effect: 'fade',
        // autoHeight: true,
        // loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },

        navigation: {
          nextEl: $('.more_in_category .swiper-button-next'),
          prevEl: $('.more_in_category .swiper-button-prev'),
        },
        scrollbar: {
          el: $('.more_in_category .swiper-scrollbar'),
          hide: false,
        },

        breakpoints: breakpoints,

      });
  }



})(window, document, jQuery);
